namespace TabAurous.Inventory {
    export interface StockAllocationItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        RefVoucherId?: number;
        DepartmentId?: number;
        DeptName?: string;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        CostMethodId?: number;
        TaxCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        DesignId?: number;
        DesignCode?: string;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        WstPer?: number;
        WstWt?: number;
        BOMDetails?: StockAllocationItemsBOMRow[];
        AllocatedItems?: StockAllocatedItemsRow[];
        Purity?: number;
        PureWeight?: number;
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
        AllocatedPieces?: number;
        AllocatedWeight?: number;
        HUID?: string;
        StampId?: number;
        StoneRate?: number;
        OtherRate?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
    }

    export namespace StockAllocationItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Inventory.StockAllocationItems';
        export const deletePermission = 'Inventory:StockAllocation:Delete';
        export const insertPermission = 'Inventory:StockAllocation:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:StockAllocation:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            DeptName = "DeptName",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            CostMethodId = "CostMethodId",
            TaxCode = "TaxCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            WstPer = "WstPer",
            WstWt = "WstWt",
            BOMDetails = "BOMDetails",
            AllocatedItems = "AllocatedItems",
            Purity = "Purity",
            PureWeight = "PureWeight",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalId = "MetalId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            AllocatedPieces = "AllocatedPieces",
            AllocatedWeight = "AllocatedWeight",
            HUID = "HUID",
            StampId = "StampId",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount"
        }
    }
}
